export interface Answers {
    correct: string;
    incorrect: string;
}

export interface SubtestRule {
    questions: number;
    maximum: number;
    penalty: number;
    minimum: number;
}

export const MOSSOS_RULES = {
    knowledge: { questions: 30, maximum: 10, penalty: 0.25, minimum: 4 },
    aptitude: { questions: 80, maximum: 10, penalty: 0, minimum: 5 },
    language: { questions: 6, maximum: 1.5, penalty: 0.25, minimum: 0 },
} satisfies Record<string, SubtestRule>;

type SubtestResult =
    | { valid: true; score: number; blank: number }
    | { valid: false; error: string };

export function calculateSubtest(
    answers: Answers,
    rule: SubtestRule,
): SubtestResult {
    const values = [answers.correct, answers.incorrect];
    if (
        values.some(
            (value) =>
                value !== "" &&
                (!/^\d+$/.test(value) || !Number.isSafeInteger(Number(value))),
        )
    ) {
        return {
            valid: false,
            error: "Introdueix només nombres enters iguals o superiors a zero.",
        };
    }

    const correct = Number(answers.correct);
    const incorrect = Number(answers.incorrect);
    const blank = rule.questions - correct - incorrect;

    if (correct + incorrect > rule.questions) {
        return {
            valid: false,
            error: `Els encerts i els errors no poden superar les ${rule.questions} preguntes.`,
        };
    }
    return {
        valid: true,
        score: Math.max(
            0,
            ((correct - incorrect * rule.penalty) * rule.maximum) /
                rule.questions,
        ),
        blank,
    };
}
